<template>
<v-layout>
  <v-flex>
<v-card>
  <v-card-title>
      <h3 class="headline mb-0 admin-header">Monitoring Groups</h3>
      <v-btn text icon color="grey lighten-1" @click="refreshList"><v-icon>fas fa-sync</v-icon></v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="fal fa-search"
        placeholder="Search"
        single-line
        hide-details
        clearable
      ></v-text-field>
      <v-flex xs1>
      <v-dialog v-model="deletedDialog" max-width="1000px">
       <deleted-access-groups v-if="deletedDialog" @accessGroupUnDeleted="refreshList" @accessGroupsUnDeleted="refreshList"></deleted-access-groups>
      </v-dialog>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="deletedDialog=true" v-bind="attrs" v-on="on">
            <v-icon size=20 color="grey lighten-1">far fa-recycle</v-icon>
          </v-btn>
        </template>
        <span>Manage Recycle Bin</span>
      </v-tooltip>

      </v-flex>
    </v-card-title>
  <v-data-table
    :options.sync="pagination"
    :headers="headers"
    :items="filteredGroups"
    :search="search"
    :loading="loading"
    class="elevation-1"
  >
    <template v-slot:item.id="{item}">
      <td v-if="isProfessional || isSU">{{ item.id }}</td>
    </template>
    <template v-slot:item.name="{item}">
      <td>
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-icon v-if="item.default" v-on="on">fas fa-users</v-icon>
          </template>
          <span>Public Group</span>
        </v-tooltip>
        <router-link :to="{ name: 'monitoringGroupConfig', params: { id: item.id }}">
              {{ item.name }}
        </router-link >
      </td>
    </template>
    <template v-slot:item.updatedDate="{item}">
      <td>{{ formatDateTime(item.updatedDate) }}</td>
    </template>
    <template v-slot:item.actions="{item}">
      <td class="actions">
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn text icon :to="{ name: 'monitoringGroupConfig', params: { id: item.id }}" v-on="on"
            style="height: 0px; width: 0px; padding-right:2px;">
                  <v-icon color="grey lighten-1" style="font-size: 18px;">fas fa-pencil</v-icon>
            </v-btn >
          </template>
        <span>Edit</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn text icon  v-if="!item.default" @click="deleteAccessGroup(item)" v-on="on">
                  <v-icon color="grey lighten-1" >fas fa-trash</v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn text icon @click="changePassword(item)"
             v-if="item.endpoints && item.endpoints.length"
             v-on="on">
                  <v-icon color="grey lighten-1" >far fa-lock</v-icon>
            </v-btn>
          </template>
          <span>Change password of associated endpoints</span>
        </v-tooltip>
      </td>
    </template>
    <v-alert slot="no-results" :value="true" color="error" type="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
        <v-dialog v-model="pwdChangeDialog" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Set Password for Endpoints in Monitoring Group</span>
          </v-card-title>
          <v-card-text>
            <v-form v-model="validPwd" @submit.prevent>
              <v-text-field v-model="newLogin" :rules="[rules.required]" label="Login"></v-text-field>
              <v-text-field v-model="newPassword" :rules="[rules.required]" type="password" label="Password"></v-text-field>
              <v-text-field v-model="confirmPassword" :rules="[rules.match]" type="password" label="Confirm Password"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="mr-4" color="primary" outlined rounded  @click.native="closeBulkPasswordDialog">Cancel</v-btn>
            <v-btn color="primary" rounded  :disabled="!validPwd" @click.native="saveBulkPassword">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

  <v-card-actions>
    <button class="btn btn-primary" @click="setupNewAccessGroup">New Monitoring Group</button>
  </v-card-actions>
</v-card>
  </v-flex>
</v-layout>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import DeletedAccessGroups from './DeletedAccessGroups.vue'
export default {
  components: {
    'deleted-access-groups': DeletedAccessGroups
  },
  data(){
      return {
        search: '',
        loading: false,
        validPwd: false,
        headers: [
          {text: 'Name', align: 'left', sortable: true, value: 'name'},
          {text: 'Description', align: 'left', sortable: true, value: 'description'},
          {text: 'Endpoints', align: 'left', sortable: true, value: 'endpointCount'},
          {text: 'Users', align: 'left', sortable: true, value: 'userWithCount'},
          {text: 'Updated', align: 'left', sortable: true, value: 'updatedDate'},
          {text: 'Actions', align: 'left', sortable: true, value: 'actions', width: '120px'}
        ],
        activeAccessGroupForPwd: {},
        pwdChangeDialog: false,
        deletedDialog: false,
        newLogin: '',
        newPassword: '',
        confirmPassword: '',
        rules: {
          required: value => !!value || 'Required.',
          match: value => value === this.newPassword || 'Passwords do not match'
        }
      }
  },
  computed: {
    ...mapGetters('endpoints', {
        accessGroups: 'accessGroups',
        paginationStore: 'getAgPagination'
    }),
    ...mapGetters('user', {
        orgContext: 'getOrgContext',
        isProfessional: 'isProfessional',
        isSU: 'isSU'
    }),
    filteredGroups: {
      get() {
        if (this.isSU || !this.accessGroups) {
          return this.accessGroups
        }
        return _.filter(this.accessGroups, (grp) => { return !grp.name.includes('∞') })
      }
    },
    pagination: {
      get() {
        return this.paginationStore
      },
      set(val) {
        if (val.stored) {
          this.$store.dispatch('endpoints/setAgPagination', val)
        }
      }
    }
  },
  async created () {
    if (this.isProfessional || this.isSU) {
      this.headers.unshift({text: 'Id', align: 'left', sortable: true, value: 'id'})
    }
    this.loading = true
    await this.$store.dispatch('user/getAllUsers')
    await this.$store.dispatch('endpoints/getAllEndpointsOnly')
    await this.$store.dispatch('endpoints/getAllAccessGroups')
    this.loading = false
  },
  watch: {
    orgContext: async function(val) {

      this.loading = true
      await this.$store.dispatch('user/getAllUsers')
      await this.$store.dispatch('endpoints/getAllEndpointsOnly')
      await this.$store.dispatch('endpoints/getAllAccessGroups')
      this.loading = false
    }
  },
  methods: {
    formatDateTime(val) {
      return moment(val).format('MM/DD/YYYY, h:mm:ss a')
    },
    async deleteAccessGroup(accessgroup) {
      if (confirm('Do you wish to delete ' + accessgroup.name + '? '
                  + 'You will no longer be able to access the monitoring group or associated data.')) {
        await this.$store.dispatch('endpoints/deleteAccessGroup', accessgroup)
      }
    },
    async setupNewAccessGroup () {
      this.$store.dispatch("endpoints/setupNewAccessGroup");
      this.$router.replace({ name: "monitoringGroupConfig", params: { id: 0 } });
    },
    changePassword(accessGroup) {
      this.activeAccessGroupForPwd = accessGroup
      this.pwdChangeDialog = true
    },
    closeBulkPasswordDialog() {
      this.activeAccessGroupForPwd = {}
      this.pwdChangeDialog = false
    },
    async saveBulkPassword() {
      let endpointIds = _.map(this.activeAccessGroupForPwd.endpoints, 'id')
      let success = await this.$store.dispatch('endpoints/setBulkPassword', { endpointIds, newLogin: this.newLogin, newPassword: this.newPassword })
      if (success) {
        this.activeAccessGroupForPwd = {}
        this.pwdChangeDialog = false
      }
    },
    async refreshList() {
      this.loading = true
      await this.$store.dispatch('endpoints/getAllAccessGroups')
      this.loading = false
    }
  }
}
</script>
<style scoped>
.actions {
  button.v-btn {
    display: inline-block;
    width: 24px;
    height: 24px;
    margin: 0;
  }

  button.v-btn.v-size--default .v-icon {
    font-size: 18px;
  }
}
</style>
